<template>
  <b-dropdown id="userAvatarDropdownButton" variant="outline-primary" class="c-topbar__action" toggle-class="btn-sm dropdown-toggle dropdown-toggle--no-caret">
    <template v-slot:button-content>
      <mtg-icon icon="ic-user" viewBox="0 0 22 24"></mtg-icon>
    </template>
    <b-dropdown-item to="/user-profile">{{ $t("lang.label_profile") }}</b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item @click="userLogout()">
      <strong>{{ $t("lang.label_logout") }}</strong>
    </b-dropdown-item>
  </b-dropdown>
</template>
<script>
export default {
  name: "UserProfileDropdown",
  props: ["items"],

  methods: {
    userLogout() {
      this.$store.dispatch("auth/logout");
    }
  }
};
</script>
